import React from 'react';
import '../styles/components/Faqs.scss';

const FaqComponent = ({ faqs }) => {
  return (
    <>
      <h2 className='faqs-title'>Faqs</h2>
      <div className="accordion" id="faqAccordion">
        {faqs.map((faq, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {faq.question}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${index}`}
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">{faq.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default FaqComponent;

// Usage example
// import FaqComponent from './FaqComponent';
//
// const faqs = [
//   { question: 'What is React?', answer: 'React is a JavaScript library for building user interfaces.' },
//   { question: 'What is Bootstrap?', answer: 'Bootstrap is a CSS framework for developing responsive and mobile-first websites.' },
//   { question: 'How do I use this FAQ component?', answer: 'Pass an array of FAQ objects to the component as a prop.' },
// ];
//
// <FaqComponent faqs={faqs} />
